import { render, staticRenderFns } from "./lawyerDialogue.vue?vue&type=template&id=9a4a1eaa&scoped=true"
import script from "./lawyerDialogue.vue?vue&type=script&lang=js"
export * from "./lawyerDialogue.vue?vue&type=script&lang=js"
import style0 from "./lawyerDialogue.vue?vue&type=style&index=0&id=9a4a1eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4a1eaa",
  null
  
)

export default component.exports